export default __webpack_public_path__ + "static/agency-banking-in-east-africa-94295b49f1fe6afd398285737769ce4f.png";